import { render } from "./slotPriceCalculator.vue?vue&type=template&id=b41fa5a4&scoped=true"
import script from "./slotPriceCalculator.vue?vue&type=script&lang=js"
export * from "./slotPriceCalculator.vue?vue&type=script&lang=js"

import "./slotPriceCalculator.vue?vue&type=style&index=0&id=b41fa5a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b41fa5a4"]])

export default __exports__